import { useCallback, useEffect, useRef } from 'react';

import { API_URL } from '../utils/api';
const SESSION_KEY = 'ltbb_session_id';

// Get or create session ID
const getSessionId = () => {
  let sessionId = localStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = `sess_${Date.now().toString(36)}_${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem(SESSION_KEY, sessionId);
  }
  return sessionId;
};

export const useTracking = () => {
  const sessionId = useRef(getSessionId());
  const vibeClickCount = useRef(0);
  
  // Initialize session on mount
  useEffect(() => {
    const initSession = async () => {
      try {
        await fetch(`${API_URL}/api/track/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ session_id: sessionId.current })
        });
      } catch (e) {
        console.log('Session init error:', e);
      }
    };
    initSession();
  }, []);
  
  // Track preview play
  const trackPreview = useCallback(async (loopId) => {
    try {
      await fetch(`${API_URL}/api/track/preview`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          loop_id: loopId,
          session_id: sessionId.current
        })
      });
    } catch (e) {
      console.log('Track preview error:', e);
    }
  }, []);
  
  // Track download
  const trackDownload = useCallback(async (loopId) => {
    try {
      await fetch(`${API_URL}/api/track/download`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          loop_id: loopId,
          session_id: sessionId.current
        })
      });
    } catch (e) {
      console.log('Track download error:', e);
    }
  }, []);
  
  // Track favorite
  const trackFavorite = useCallback(async (loopId, action = 'add') => {
    try {
      await fetch(`${API_URL}/api/track/favorite`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          loop_id: loopId,
          action: action
        })
      });
    } catch (e) {
      console.log('Track favorite error:', e);
    }
  }, []);
  
  // Track vibe click
  const trackVibeClick = useCallback(async (presetName) => {
    vibeClickCount.current += 1;
    const isFirstClick = vibeClickCount.current === 1;
    
    try {
      await fetch(`${API_URL}/api/track/vibe-click`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          preset_name: presetName,
          session_id: sessionId.current,
          is_first_click: isFirstClick
        })
      });
    } catch (e) {
      console.log('Track vibe click error:', e);
    }
  }, []);
  
  return {
    sessionId: sessionId.current,
    trackPreview,
    trackDownload,
    trackFavorite,
    trackVibeClick
  };
};
